// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Pa3K","colBig":"styles_colBig__18cVK","colSmall":"styles_colSmall__AzIfH"};